<template>
  <div>
    <SearchAndFilter
      :value="queryString"
      :filter-options="membershipGroupTypesArray"
      placeholder="Search Groups"
    />

    <div :class="{ 'load load--fill': isLoading }">
      <section
        v-if="membershipGroups.length && !isLoading"
        class="flex flex-wrap items-stretch -mx-2"
      >
        <MembershipGroup
          v-for="membershipGroup in membershipGroups"
          :key="membershipGroup.uuid"
          :membership-group="membershipGroup"
        />
      </section>
      <section
        v-if="!membershipGroups.length && !isLoading"
        class="empty mt-4"
      >
        <section>
          <h2 v-text="'There are no groups'" />
          <p>Groups are a way to organize members.</p>
          <a
            v-can="'create-membership-groups'"
            href="#"
            class="btn btn--border"
            @click.prevent="$root.$store.commit('membershipOpenCreateMembershipGroupModal')"
            v-text="'Create a group'"
          />
        </section>
      </section>
      <Pagination
        :pagination="pagination"
        :on-change="changePage"
      />
      <CreateMembershipGroupModal
        :membership-group-types="membershipGroupTypes"
        :groups-listed-inside-calendar="groupsListedInsideCalendar"
        @membershipGroupHasBeenCreated="updateMembershipGroups"
      />
    </div>
  </div>
</template>

<script type="text/babel">
import { mapState, mapActions } from 'vuex'
import MembershipGroup from './MembershipGroup'
import SearchAndFilter from 'Membership/Resources/assets/js/components/SearchAndFilter'

export default {
  name: 'MembershipGroups',
  components: {
    MembershipGroup,
    SearchAndFilter,
  },
  props: {
    membershipGroupTypes: {
      type: Array,
      required: false,
      default: () => [],
    },
    groupsListedInsideCalendar: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      queryString: {
        query: '',
        page: 1,
        filter: 'all',
      },
    }
  },
  computed: {
    ...mapState({
      pagination: state => state.membership.membershipGroups.meta.pagination,
    }),
    membershipGroups() {
      return this.$store.getters.membershipGroups
    },
    membershipGroupTypesArray() {
      const array = this.membershipGroupTypes.map(type => type.title)

      array.unshift('All')

      return array
    },
    isLoading() {
      return this.$store.state.membership.loadingMembershipGroups
    },
  }, watch: {
    queryString: {
      handler: _.debounce(function (oldValue, newValue) {
        const data = newValue

        if (newValue.query.length && (oldValue.query === newValue.query) && oldValue.page > 1) {
          data.page = 1
          this.queryString.page = 1
        }

        this.getMembershipGroups({ params: data })
      }, 500),
      deep: true,
    },
  },
  async mounted() {
    await this.$nextTick()

    this.updateMembershipGroups()
  },
  methods: {
    ...mapActions({
      getMembershipGroups: 'membershipGetMembershipGroups',
    }),
    updateMembershipGroups(){
      this.getMembershipGroups({
        params: this.queryString,
      })
    },
    showMembershipGroup(uuid) {
      window.location = this.$urlGenerator.active() + 'members/membership-groups/' + uuid
    },
    changePage(page) {
      this.queryString.page = page
    },
  },
}
</script>
